import { render, staticRenderFns } from "./_baseinfo.vue?vue&type=template&id=4fa1ba41&scoped=true&"
import script from "./_baseinfo.vue?vue&type=script&lang=js&"
export * from "./_baseinfo.vue?vue&type=script&lang=js&"
import style0 from "./_baseinfo.vue?vue&type=style&index=0&id=4fa1ba41&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa1ba41",
  null
  
)

export default component.exports